import React from 'react';
import styled from 'styled-components';

import { translate } from '~/services/translate';
import Feature from '../basic/feature';
import { ColumnFlexCentered } from '~/components/basic/containers';

const Container = styled(ColumnFlexCentered)`
  width: 600px;
  align-items: flex-start;
`;

const Title = styled.div`
  display: flex;
  font-size: 32px;
  margin-bottom : 16px;
  color: ${({ theme }) => theme.lightFont};
  line-height: 32px;
  align-items: center;
`;

const Description = styled.div`
  font-size: 32px;
  font-weight: 600;
  color: ${({ theme }) => theme.lightFont};
  margin-bottom: 26px;
`;

const Footer = styled.div`
  display: flex;
  font-weight: 600;
  font-size: 19px;
  color: ${({ theme }) => theme.lightFont};
`;

const LargeFeaturesPanel = () => (
  <Container fullWidth>
    <Title>
      <b>{translate('meetings_for_free__title')}</b>
    </Title>
    <Description />
    <Feature
      boldText={translate('meetings_for_free_feature_2_bold')}
      text={translate('meetings_for_free_feature_2_regular')}
      fontSize={19}
      iconSize={20}
    />
    <Feature
      boldText={translate('meetings_for_free_feature_3_bold')}
      text={translate('meetings_for_free_feature_3_regular')}
      fontSize={19}
      iconSize={20}
    />
    <Feature
      boldText={translate('meetings_for_free_feature_4_bold')}
      text={translate('meetings_for_free_feature_4_regular')}
      fontSize={19}
      iconSize={20}
    />
    <Feature
      boldText={translate('meetings_for_free_feature_5_bold')}
      text={translate('meetings_for_free_feature_5_regular')}
      fontSize={19}
      iconSize={20}
    />
    <Feature
      boldText={translate('meetings_for_free_feature_6_bold')}
      text={translate('meetings_for_free_feature_6_regular')}
      fontSize={19}
      iconSize={20}
    />
    <Footer>{translate('many_to_come')}</Footer>
  </Container>
);

export default LargeFeaturesPanel;